import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue";
import { defineComponent, ref, onMounted } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { getSoftwareDetailById, getSoftwareRecord, getSoftwareByCode, undoApprove,
// 撤销审核
whetherNewSoftware,
// 是否为第一次添加软件
takeDownSoftware // 申请下架
} from '@/http/api';
import { useRoute, useRouter } from 'vue-router';
import moment from 'moment';
import { htmlRestore } from '@/utils/index';
import Commercial from '../components/Commercial.vue';
// defineComponent 可以有智能提示
export default defineComponent({
  components: {
    Commercial
  },
  setup() {
    const $route = useRoute();
    const $router = useRouter();
    let softwareId = $route.params.softwareId;
    let softwareData = ref({});
    let softwareCode = '';
    let softwareContrast = ref({});
    // contrast
    let softwareRecordList = ref([]);
    let flag = ref(false);
    let stateTxt = ref('');
    const visible = ref(false);
    const getdownVisible = ref(false);
    const applyVisible = ref(false);
    const takedownReason = ref('');
    const userStr = localStorage.getItem('user');
    let tempUser = {};
    if (userStr) {
      tempUser = JSON.parse(userStr);
    }
    const userCommercial = tempUser.isCommercial;
    const imgVisible = ref(false);
    const onOpen = () => {
      imgVisible.value = true;
    };
    const close = () => {
      imgVisible.value = false;
    };
    const typemap = {
      3: '正常在架中',
      5: '软件已下架，若重新上架请新增软件',
      7: '暂时下架中，请修改后重新申请上架'
    };
    const typeColor = {
      3: '#00BE63',
      5: '#F24014',
      7: '#F24014'
    };
    let pagination = ref({
      defaultCurrent: 1,
      defaultPageSize: 5,
      totalContent: false,
      total: 0,
      showPageSize: true,
      pageSizeOptions: [{
        label: '每页 5 条',
        value: 5
      }, {
        label: '每页 10 条',
        value: 10
      }]
    });
    // 操作列表表头
    const columns = [{
      colKey: 'versions',
      title: '版本号'
    }, {
      colKey: 'create_time',
      title: '申请时间'
    }, {
      colKey: 'update_time',
      title: '处理时间'
    }, {
      colKey: 'software_state',
      title: '当前状态'
    }];
    // https://s.pc.qq.com/softdetail_v3/228/14/detail_22814.html
    // https://s.pc.qq.com/softdetail_v3/0/12/detail_12.html
    const watchDetail = () => {
      // 水滴 软件详情页-查看详情（拉起软管软件详情页）按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '23'
      });
      // softwareData
      const softid = softwareData.value.manager_id;
      // const tempId = softid / 100;
      // const parseIntId = parseInt(tempId.toString());
      // const detailUrl =
      //   'https://' +
      //   `s.pc.qq.com/softdetail_v3/${parseIntId}/${
      //     softid % 100
      //   }/detail_${softid}` +
      //   '.html';
      const test = location.host !== 'guanjia.qq.com';
      let detailUrl = `https://softcenter.qq.com/soft?id=${softid}`;
      if (test) {
        detailUrl = `https://soft.sparta.html5.qq.com/soft?id=${softid}`;
      }
      window.open(detailUrl);
    };
    async function downloadMP4File(url) {
      try {
        let filename = url.split('/').pop();
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const blob = await response.blob();
        const objectURL = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectURL;
        a.download = filename || '';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectURL);
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    }
    const goHomepage = () => {
      $router.push({
        path: '/softwarelibrary'
      });
    };
    const options = [{
      content: '提交新版本',
      value: 1
    }, {
      content: '下架软件',
      value: 2
    }];
    const optionChange = [{
      content: '下架软件',
      value: 2
    }];
    const clickHandler = data => {
      // clickHandler data.value == 1 时为提交新版本
      if (data.value == 1) {
        // 水滴 软件详情页-下拉中提交新版本按钮点击
        window._sdi.stat({
          ptype: '9',
          stype: '24'
        });
        $router.push({
          path: `/addnewversion/${softwareId}`
        });
      }
      // data.value == 1 时为下架软件
      if (data.value == 2) {
        applyVisible.value = true;
      }
    };
    // 已驳回 -> 查看理由 -> 去修改
    const onConfirmAnother = async () => {
      // 水滴 软件详情页-软件审核被驳回——去修改按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '28'
      });
      // $router.push({ path: `/softwareupdate/${softwareId}` });
      const res = await whetherNewSoftware({
        software_code: softwareCode
      });
      const {
        result,
        code,
        isNew
      } = res;
      if (result && code == 200) {
        if (isNew) {
          $router.push({
            path: `/addnewsoftware/${softwareId}`
          });
        } else if (!isNew) {
          $router.push({
            path: `/softwareupdate/${softwareId}`
          });
        }
      }
      visible.value = false;
      getdownVisible.value = false;
    };
    const rejectReason = () => {
      visible.value = true;
    };
    const getdownReason = () => {
      // 水滴 软件详情页-软件审核被驳回——查看理由按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '27'
      });
      getdownVisible.value = true;
    };
    // 下架软件 -> 取消
    const applyConfirm = () => {
      applyVisible.value = false;
    };
    // 下架软件 -> 申请下架
    const applyCancel = async () => {
      // 水滴 软件详情页-下拉中下架软件按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '25'
      });
      applyVisible.value = false;
      const res = await takeDownSoftware({
        softwareId: softwareContrast.value.software_id,
        reasons: takedownReason.value
      });
      if (res.effect && res.result) {
        $router.push({
          path: '/feedback/takedown'
        });
      } else {
        MessagePlugin.error('下架软件失败');
        location.reload();
      }
    };
    // 取消下架
    const cancelApply = () => {
      return _createVNode(_resolveComponent("t-button"), {
        "theme": "primary",
        "variant": "outline",
        "style": "width: 154px; height: 44px; font-size: 16px;"
      }, {
        default: () => [_createTextVNode("\u53D6\u6D88")]
      });
    };
    // 申请下架
    const applyTakedown = () => {
      return _createVNode(_resolveComponent("t-button"), {
        "theme": "primary",
        "style": "width: 154px; height: 44px; font-size: 16px;"
      }, {
        default: () => [_createTextVNode("\u7533\u8BF7\u4E0B\u67B6")]
      });
    };
    onMounted(async () => {
      // 水滴 软件详情页-页面曝光
      window._sdi.stat({
        ptype: '9',
        stype: '22'
      });
      // 获取软件信息
      const res = await getSoftwareDetailById({
        softwareId
      });
      if (res.code == 200 && res.result) {
        softwareData.value = res.data;
        softwareData.value.software_name = htmlRestore(res.data.software_name);
      }
      console.log('软件信息 ====>', res);
      if (softwareData.value.software_state == 1) stateTxt.value = '草稿保存中，草稿仅保存30天，请尽快提交';
      if (softwareData.value.software_state == 2 || softwareData.value.software_state == 8) {
        stateTxt.value = '上架审核中，若需修改请撤回审核后编辑';
      }
      if (softwareData.value.software_state == 4) {
        stateTxt.value = '下架审核中，申请通过后若重新上架需走新增软件流程';
      }
      if (softwareData.value.software_state == 6) {
        stateTxt.value = '已驳回，可点击查看驳回理由。请修改后重新提交上架';
      }
      softwareCode = res.data.software_code;
      // 获取操作记录 pagination
      const data = await getSoftwareRecord({
        softwareCode,
        pageNum: 1,
        pageSize: 5
      });
      if (data.code == 200 && data.result) {
        softwareRecordList.value = data.data;
        pagination.value.total = data.data.length;
      }
      for (let key of softwareRecordList.value) {
        key.create_time = moment(key.create_time).format('YYYY-MM-DD');
        key.update_time = moment(key.update_time).format('YYYY-MM-DD');
      }
      const resContrast = await getSoftwareByCode({
        software_code: softwareCode
      });
      if (resContrast.code == 200 && resContrast.result) {
        softwareContrast.value = resContrast.data[0] || '';
      }
    });
    // 提交新版本
    const submitNew = () => {
      // 水滴 软件详情页-审核版本中提交新版本按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '26'
      });
      if (softwareData.value.software_state == 5 || softwareData.value.software_state == 7) return;
      $router.push({
        path: `/addnewversion/${softwareId}`
      });
    };
    // 撤销审核
    const undo = async () => {
      visibleSave.value = true;
    };
    const visibleSave = ref(false);
    const clickConfirm = async () => {
      visibleSave.value = false;
      const undoParam = {
        softwareId: softwareData.value.software_id,
        versions: softwareData.value.versions,
        softwareName: softwareData.value.software_name
      };
      const res = await undoApprove(undoParam);
      if (res.effect && res.result) {
        MessagePlugin.success('撤销审核成功');
        location.reload();
      } else {
        MessagePlugin.error('撤销审核失败');
        location.reload();
      }
    };
    const clickCancel = () => {
      visibleSave.value = false;
    };
    const getConfirmBtn = () => {
      return _createVNode(_resolveComponent("t-button"), {
        "variant": "outline",
        "theme": "primary",
        "onClick": () => clickCancel(),
        "class": "dialog-cancel-btn"
      }, {
        default: () => [_createTextVNode("\u53D6 \u6D88")]
      });
    };
    const getCancelBtn = () => {
      return _createVNode(_resolveComponent("t-button"), {
        "theme": "primary",
        "type": "submit",
        "onClick": () => clickConfirm(),
        "class": "dialog-confirm-btn"
      }, {
        default: () => [_createTextVNode("\u786E \u8BA4")]
      });
    };
    const getBody = () => {
      return _createVNode("div", {
        "class": "dialog-getbody"
      }, [_createVNode("p", null, [_createTextVNode(" \u64A4\u9500\u540E\u9700\u8981\u91CD\u65B0\u63D0\u4EA4\u5BA1\u6838\uFF0C\u662F\u5426\u786E\u8BA4\u64A4\u9500\u5BA1\u6838 ")]), _createVNode("p", null, [_createTextVNode(" \u64CD\u4F5C\uFF1F ")])]);
    };
    const getHeader = () => {
      return _createVNode("div", {
        "class": "dialog-getheader"
      }, [_createTextVNode("\u63D0\u793A")]);
    };
    // 编辑草稿
    const saveDraft = async () => {
      const res = await whetherNewSoftware({
        software_code: softwareCode
      });
      const {
        result,
        code,
        isNew
      } = res;
      if (result && code == 200) {
        if (isNew) {
          $router.push({
            path: `/addnewsoftware/${softwareId}`
          });
        } else if (!isNew) {
          $router.push({
            path: `/softwareupdate/${softwareId}`
          });
        }
      }
    };
    const goContactus = () => {
      window.open('/software-platform/contactus');
    };
    return {
      userCommercial,
      columns,
      pagination,
      watchDetail,
      options,
      optionChange,
      clickHandler,
      softwareData,
      softwareContrast,
      softwareRecordList,
      flag,
      stateTxt,
      softwareId,
      typemap,
      typeColor,
      submitNew,
      undo,
      saveDraft,
      visible,
      onConfirmAnother,
      rejectReason,
      getdownVisible,
      getdownReason,
      applyVisible,
      applyConfirm,
      applyCancel,
      cancelApply,
      applyTakedown,
      takedownReason,
      goHomepage,
      visibleSave,
      getConfirmBtn,
      getCancelBtn,
      getBody,
      getHeader,
      goContactus,
      close,
      onOpen,
      imgVisible,
      downloadMP4File
    };
  }
});